const actionPrefix = (actionType) => `TreatmentBrands/${actionType}`;

export const SET_TREATMENT_BRANDS = actionPrefix`SET_TREATMENT_BRANDS`;

const setTreatmentBrands = (treatmentBrands) => ({
  type: SET_TREATMENT_BRANDS,
  payload: treatmentBrands,
});

export const treatmentBrandsActions = {
  setTreatmentBrands,
};
